// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import "react-toastify/dist/ReactToastify.css";
//
// import axios from "axios";
// import myFormSchema from "../../schema/HiringForm";
// import { useForm } from "react-hook-form";
// import { zodResolver } from "@hookform/resolvers/zod";
// import Config from "../../Config/config";
"use client";
import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import { z } from "zod";
import { ArrowRight, Check, AlertCircle } from "lucide-react";

// Form validation schema
const formSchema = z.object({
  name: z.string().min(2, { message: "Name must be at least 2 characters" }),
  email: z.string().email({ message: "Please enter a valid email address" }),
  problem: z
    .string()
    .min(10, { message: "Problem description must be at least 10 characters" }),
});

const Hiring = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    problem: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState("idle");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    }
  };

  const validateForm = () => {
    try {
      formSchema.parse(formData);
      setErrors({});
      return true;
    } catch (error) {
      if (error instanceof z.ZodError) {
        const newErrors = {};
        error.errors.forEach((err) => {
          if (err.path[0]) {
            newErrors[err.path[0]] = err.message;
          }
        });
        setErrors(newErrors);
      }
      return false;
    }
  };

  const handleSubmit = async (e) => {
    debugger;
    e.preventDefault();

    if (!validateForm()) return;

    setIsSubmitting(true);
    setSubmitStatus("idle");

    try {
      const response = await fetch(
        "https://api.airtable.com/v0/appg2h3NGPhBXWS2F/Table%201",
        {
          method: "POST",
          headers: {
            Authorization:
              "Bearer patA3HkkpgvYh4xfW.13032c4d4637b63fe9919221600aac5b3663609ad5fe3658b60705ca0db633fd",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            records: [
              {
                fields: {
                  Name: formData.name,
                  Email: formData.email,
                  Status: "False",
                  Problem: formData.problem,
                },
              },
            ],
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      // Reset form on success
      setFormData({ name: "", email: "", problem: "" });
      setSubmitStatus("success");
    } catch (error) {
      console.error("Submission error:", error);
      setErrorMessage(
        error instanceof Error ? error.message : "An unknown error occurred"
      );
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const formStyles = {
    fieldGroup: {
      display: "flex",
      flexDirection: "column",
      gap: "0.5rem",
    },
    label: {
      fontWeight: "500",
      fontSize: "0.875rem",
    },
    input: {
      padding: "0.5rem",
      border: "1px solid #ccc",
      borderRadius: "0.25rem",
      fontSize: "1rem",
      width: "100%",
    },
    inputError: {
      border: "1px solid #e11d48",
    },
    textarea: {
      padding: "0.5rem",
      border: "1px solid #ccc",
      borderRadius: "0.25rem",
      fontSize: "1rem",
      minHeight: "100px",
      resize: "vertical",
    },
    errorText: {
      color: "#e11d48",
      fontSize: "0.75rem",
      marginTop: "0.25rem",
    },
    button: {
      backgroundColor: "#3b82f6",
      color: "white",
      padding: "0.5rem 1rem",
      borderRadius: "0.25rem",
      fontSize: "1rem",
      cursor: "pointer",
      border: "none",
    },
    buttonDisabled: {
      opacity: 0.7,
      cursor: "not-allowed",
    },
    alert: {
      padding: "0.75rem",
      borderRadius: "0.25rem",
      display: "flex",
      alignItems: "center",
      gap: "0.5rem",
    },
    successAlert: {
      backgroundColor: "#ecfdf5",
      border: "1px solid #a7f3d0",
      color: "#047857",
    },
    errorAlert: {
      backgroundColor: "#fef2f2",
      border: "1px solid #fecaca",
      color: "#b91c1c",
    },
  };
  const FeatureItem = ({ title, description }) => (
    <div className="flex items-start">
      <div className="flex-shrink-0">
        <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-blue-400 bg-opacity-30">
          <Check className="w-5 h-5 text-blue-200" />
        </div>
      </div>
      <div className="ml-4">
        <h3 className="text-lg font-semibold text-white">{title}</h3>
        <p className="mt-1 text-blue-200">{description}</p>
      </div>
    </div>
  );

  return (
    <div className="Login ">
      <main className="profile-page">
        <section className="bg-white">
          <div className="grid grid-cols-1 lg:grid-cols-2 h-[100vh]">
            <div className="relative flex items-center px-8 py-16 md:px-12 lg:px-16 bg-gradient-to-br from-indigo-900 via-blue-800 to-purple-900 overflow-hidden">
              <div className="absolute inset-0 opacity-20">
                <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.2)_0%,rgba(0,0,0,0)_60%)]"></div>
                <div className="absolute bottom-0 right-0 w-80 h-80 bg-[radial-gradient(circle,rgba(255,255,255,0.3)_0%,rgba(0,0,0,0)_70%)]"></div>
              </div>

              <div className="relative flex flex-col max-w-xl mx-auto">
                <div className="flex-shrink-0 mb-12">
                  <a href="/" className="flex items-center">
                    <img
                      className="w-auto h-12 "
                      src={require("../../assets/images/sofyrus_b39d664183.webp")}
                      alt=""
                    />
                  </a>
                </div>

                <div className="space-y-6">
                  <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight">
                    Join Our <span className="text-blue-300">Exclusive</span>{" "}
                    Waitlist
                  </h2>

                  <p className="text-lg text-blue-100 leading-relaxed">
                    Be the first to access our platform when we launch.
                  </p>

                  <div className="pt-6 space-y-8">
                    <FeatureItem
                      title="Vetted Freelancers & Teams"
                      description="Premium talent guaranteed for your projects"
                    />

                    <FeatureItem
                      title="Blockchain Backed Profiles"
                      description="Removing biases for paid promoted profiles"
                    />

                    <FeatureItem
                      title="Find work over all of the internet"
                      description="Not just our platform we find projects from all over the internet"
                    />

                    <FeatureItem
                      title="Flexible Solutions"
                      description="Complete teams or on-demand developers as needed"
                    />
                  </div>
                </div>
              </div>
            </div>
            {/*  {showMessage ? (
                <div className="space-y-5 ">
                  <h3 className=" text-2xl lg:text-4xl w-[100%]  md:text-xl mx-w-[60%] font-bold text-black mb-3 lg:px-6 px-4">
                    Thank you for connecting with us. <br></br>We will come back
                    to you within the next 24 hours
                  </h3>
                </div>
              ) : (
                <div className="xl:w-full xl:max-w-sm 2xl:max-w-md xl:mx-auto">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="space-y-5">
                      <div>
                        <label
                          htmlFor=""
                          className="text-sm font-medium text-gray-900 red"
                        >
                          First Name
                        </label>
                        <div className="mt-2.5 relative text-gray-400 focus-within:text-gray-600 pb-1">
                          <input
                            type="text"
                            name="userName"
                            {...register("firstName")}
                            id=""
                            className="block w-full py-2 pl-2 pr-4 text-black placeholder-gray-500 transition-all duration-200 border border-gray-200 rounded-md  focus:outline-none focus:border-blue-600 focus:bg-white caret-blue-600"
                            onChange={(Event) =>
                              fullNameHandler("firstName", Event.target.value)
                            }
                          />
                        </div>
                        {errors.firstName?.message.length && (
                          <span className="text-red-500 text-sm font-medium">
                            {errors.firstName?.message}
                          </span>
                        )}
                      </div>
                      <div>
                        <label
                          htmlFor=""
                          className="text-sm font-medium text-gray-900 red"
                        >
                          Last Name
                        </label>
                        <div className="mt-2.5 relative text-gray-400 focus-within:text-gray-600 pb-1">
                          <input
                            type="text"
                            name="userName"
                            {...register("lastName")}
                            id=""
                            className="block w-full py-2 pl-2 pr-4 text-black placeholder-gray-500 transition-all duration-200 border border-gray-200 rounded-md  focus:outline-none focus:border-blue-600 focus:bg-white caret-blue-600"
                            onChange={(Event) =>
                              fullNameHandler("lastName", Event.target.value)
                            }
                          />
                        </div>
                      </div>
                      {errors?.lastName?.message.length ? (
                        <span className="text-red-500 text-sm font-medium">
                          {errors.lastName?.message}
                        </span>
                      ) : null}

                      <div>
                        <label
                          htmlFor=""
                          className="text-sm font-medium text-gray-900 red"
                        >
                          Email
                        </label>
                        <div className="mt-2.5 relative text-gray-400 focus-within:text-gray-600 pb-1">
                          <input
                            type="email"
                            name="userEmail"
                            {...register("userEmail")}
                            id=""
                            className="block w-full py-2 pl-2 pr-4 text-black placeholder-gray-500 transition-all duration-200 border border-gray-200 rounded-md  focus:outline-none focus:border-blue-600 focus:bg-white caret-blue-600"
                            onChange={(Event) =>
                              HandleChange("userEmail", Event.target.value)
                            }
                          />
                        </div>
                        {errors.userEmail?.message.length && (
                          <span className="text-red-500 text-sm font-medium">
                            {errors.userEmail.message}
                          </span>
                        )}
                      </div>

                      <div>
                        <button
                          type="submit"
                          className="inline-flex items-center justify-center w-full px-4 py-2 text-base font-semibold text-white transition-all duration-200 border border-transparent rounded-md bg-blue-500 focus:outline-none hover:opacity-80 focus:opacity-80"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              )}
                */}
            <div className="flex flex-col items-center justify-center px-4 py-7 bg-white sm:px-6 lg:px-8 sm:py-2 lg:py-24">
              <div className="text-left mb-3">
                <h2 className="text-2xl font-bold text-gray-900">
                  Join Our Waitlist
                </h2>
                <p className="mt-2 text-sm text-gray-600">
                  Fill out the form below and we'll notify you when we launch
                </p>
              </div>
              <form
                onSubmit={handleSubmit}
                className="flex flex-col gap-3 lg:w-[60%] w-full"
              >
                {submitStatus === "success" && (
                  <div
                    style={{ ...formStyles.alert, ...formStyles.successAlert }}
                  >
                    ✓ Your form has been submitted successfully!
                  </div>
                )}

                {submitStatus === "error" && (
                  <div
                    style={{ ...formStyles.alert, ...formStyles.errorAlert }}
                  >
                    ⚠{" "}
                    {errorMessage ||
                      "There was an error submitting your form. Please try again."}
                  </div>
                )}

                <div style={formStyles.fieldGroup}>
                  <label htmlFor="name" style={formStyles.label}>
                    Name
                  </label>
                  <input
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your name"
                    style={{
                      ...formStyles.input,
                      ...(errors.name ? formStyles.inputError : {}),
                    }}
                  />
                  {errors.name && (
                    <p style={formStyles.errorText}>{errors.name}</p>
                  )}
                </div>

                <div style={formStyles.fieldGroup}>
                  <label htmlFor="email" style={formStyles.label}>
                    Email
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="your.email@example.com"
                    style={{
                      ...formStyles.input,
                      ...(errors.email ? formStyles.inputError : {}),
                    }}
                  />
                  {errors.email && (
                    <p style={formStyles.errorText}>{errors.email}</p>
                  )}
                </div>

                <div style={formStyles.fieldGroup}>
                  <label htmlFor="problem" style={formStyles.label}>
                    Problem Description
                  </label>
                  <textarea
                    id="problem"
                    name="problem"
                    value={formData.problem}
                    onChange={handleChange}
                    placeholder="Please describe your problem in detail"
                    style={{
                      ...formStyles.textarea,
                      ...(errors.problem ? formStyles.inputError : {}),
                    }}
                    rows={4}
                  />
                  {errors.problem && (
                    <p style={formStyles.errorText}>{errors.problem}</p>
                  )}
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  style={{
                    ...formStyles.button,
                    ...(isSubmitting ? formStyles.buttonDisabled : {}),
                  }}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </form>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Hiring;
